/*
 * edmlandingpage.js
 * EDM Landing Page Controller Javascript
 * @Company: Strange Animals
 * @Author: Safet Ziljkic
 * ----------------------------------
 */

$(document).ready(function() {
    /* Play Button */

    var playButton = $('.play-button-edm');
    var edmLandingModal = $('.edm-landing-video-modal');
    var $vid = edmLandingModal.find('iframe');
    var youtubeId = null;

    //*** Video Modal Controller ***

    playButton.on('click', function(e) {
        e.preventDefault();
        youtubeId = $(this).data('youtube-id');
        $vid.attr('src', 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&controls=0&showinfo=0&rel=0');
        //Launch and Play Modal
        UIkit.modal(edmLandingModal).show();
    });

    edmLandingModal.on('hidden.bs.modal', function(e) {
        $vid.attr('src', '');
    });

    //*** Form Modal Controller ***
    var $enquiryFormModal = $('#ContactFormModal');
    var $edmFormModal = $('#DisplayTourFormModal');
    var $appointmentBtn = $('.appointment-btn');

    $appointmentBtn.on('click', function() {
        if ($(this).data('form') === 'enquiry') {
            UIkit.modal($enquiryFormModal).show();
        } else {
            UIkit.modal($edmFormModal).show();
        }
        $appointmentBtn.removeAttr('hidden');
    });

    //Add required field class to form Date picker field.
    $('#PreferredDate').addClass('required-field');
    // $('#PreferredDate').find('input').addClass('form-control');

    //Slider Initation
    $('.edm-landing-slider').not('.slick-initialized').slick({
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: false,
        dots: false,
        variableWidth: true,
        autoplay: true
    });
});
